import Vue from "vue";
import Echo from "laravel-echo";
import VueI18n from "vue-i18n";

import de from "./locales/de.json";
import en from "./locales/en.json";
import sl from "./locales/sl.json";

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: "en",
  fallbackLocale: "en",
  messages: {
    de: de,
    en: en,
    sl: sl
  }
});

window.io = require("socket.io-client");
if (window.location.hostname.includes("localhost")) {
  window.Echo = new Echo({
    broadcaster: "socket.io",
    //host: window.location.hostname+':'+location.port // Line for local development and remote socket.io
    host: "localhost:6001" // Line for local development and local socket.io
  });
} else {
  window.Echo = new Echo({
    broadcaster: "socket.io",
    host: window.location.hostname
  });
}

import App from "./App.vue";

Vue.config.productionTip = false;

new Vue({
  i18n,
  render: (h) => h(App)
}).$mount("#app");
